import {
  RouteLocationNormalizedLoaded,
  Router,
} from 'vue-router';

export const getRouteParams = (route: any) => ({
  ...(route.params.month && { month: route.params.month }),
  ...(route.params.week && { week: route.params.week }),
  ...{ year: route.params.year, day: route.params.day },
});

export const rerouteToOverview = (
  route: RouteLocationNormalizedLoaded,
  router: Router,
): void => {
  let routename = 'calendar-week-view';
  if (String(route.name).includes('month')) {
    routename = 'calendar-month-view';
  }

  router.push({
    name: routename,
    params: { ...getRouteParams(route) },
  });
};
